import { useState } from 'react';
import SingleTextEditor from '../common/editors/SingleTextEditor';
import { SwitchInput } from '../common/SwitchInput';
import _ from 'lodash';
import MultiValueSelector from '../common/editors/MultiValueSelector';
import SingleValueSelector from '../common/editors/SingleValueSelector';
import ModelContextEditor from '../lego/ModelContextEditor';
import { LocalesSelector } from '../lego/LocalesSelector';
import AIModelSelector from '../../pages/cerokm/components/AIModelSelector';
import ModelIdSelector from '../lego/ModelIdSelector';

export default function ScriptParameterModal({ script, onCancel, onSubmit }) {
  const { parametersDefinition } = script;

  let defaultParams = {};
  _.each(parametersDefinition, p => defaultParams[p.id] = p.defaultValue);

  let [params, setParams] = useState({ ...defaultParams, ...script.initialParams });

  let paramsControls = parametersDefinition?.map(({ id, type, description, options, optional, defaultValue }) => {
    let descriptionElem = <span dangerouslySetInnerHTML={{ __html: description }} />;
    let value = params[id];
    if (type === 'string') {
      return <div key={id} className={'p-2'}>
        {descriptionElem}
        <SingleTextEditor placeholder={id} value={value} onChange={v => setParams(p => ({ ...p, [id]: v }))} />
      </div>
    } else if (type === 'select') {
      return <div key={id} className={'p-2'}>
        {descriptionElem}
        <SingleValueSelector placeholder={id} value={value || defaultValue} options={options} onChange={v => setParams(p => ({ ...p, [id]: v }))} />
      </div>
    } else if (type === 'legoContext') {
      return <div key={id} className={'p-2'}>
        {descriptionElem}
        <ModelContextEditor placeholder={id} value={value} onChange={v => setParams(p => ({ ...p, [id]: v }))} />
      </div>
    } else if (type === 'modelId') {
      return <div key={id} className={'p-2'}>
        {descriptionElem}
        <ModelIdSelector placeholder={id} value={value} onChange={v => setParams(p => ({ ...p, [id]: v }))} />
      </div>
    } else if (type === 'modelIds') {
      return <div key={id} className={'p-2'}>
        {descriptionElem}
        <ModelIdSelector multi value={value} onChange={v => setParams(p => ({ ...p, [id]: v }))} />
      </div>
    } else if (type === 'locales') {
      return <div key={id} className={'p-2'}>
        {descriptionElem}
        <LocalesSelector value={value} onChange={v => setParams(p => ({ ...p, [id]: v }))} />
      </div>
    } else if (type === 'locale') {
      return <div key={id} className={'p-2'}>
        {descriptionElem}
        <LocalesSelector multi={false} value={value} onChange={v => setParams(p => ({ ...p, [id]: v }))} />
      </div>
    } else if (type === 'boolean') {
      return <div key={id} className={'p-2'}>
        <SwitchInput value={!!value} onChange={v => setParams(p => ({ ...p, [id]: v }))}>
          {descriptionElem}
        </SwitchInput>
      </div>
    } else if (type === 'number') {
      return <div key={id} className={'p-2'}>
        {descriptionElem}:
        <input type='number' style={{ width: '100px' }} className='form-control form-control-sm d-inline-block ml-3 text-right'
          defaultValue={value ?? defaultValue} onChange={e => {
            let v = parseInt(e.target.value, 10); // Saved because setState cbk cannot use a synthetic event
            setParams(p => ({ ...p, [id]: v }));
          }} />
      </div>
    } else if (type === 'aiModel') {
      return <div key={id} className={'p-2'}>
        {descriptionElem}
        <AIModelSelector value={value} onChange={v => setParams(p => ({ ...p, [id]: v }))} />
      </div>
    } else {
      throw new Error(`Unknown parameter type ${type}`);
    }
  });

  return <div>
    {paramsControls}

    <div className={'p-2'}>
      <button className={'btn btn-success mr-2'} onClick={() => onSubmit(params)}>Run script</button>

      <button className={'btn btn-dark'} onClick={onCancel}>Cancel</button>
    </div>

    <pre className={'small bg-light rounded p-1 m-2 text-secondary'}>{JSON.stringify(params, null, 2)}</pre>
  </div>
};
